ds-title {
  display: block;
  box-sizing: border-box;
  text-rendering: optimizelegibility;

  & strong,
  & a {
    display: block;
  }

  & > h1,
  & > h2,
  & > h3,
  & > h4,
  & > h5,
  & > h6,
  & > strong,
  & > a,
  & > a:hover {
    padding: 0;
    margin: 0;
    text-rendering: optimizelegibility;
    box-sizing: border-box;
    font-family: inherit;
    line-height: inherit;
    font-size: inherit;
    text-align: inherit;
    color: inherit;
  }

  & > h1,
  & > h2,
  & > h3,
  & > h4,
  & > h5,
  & > h6,
  & > strong {
    & > a,
    & > a:hover {
      color: inherit;
    }
  }
}